import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Freno de Emergencia',
  description: 'Aplicas los remedios tópicos específicos para bajar la temperatura de la piel inmediatamente.'
}, {
  num: '02',
  title: 'Reinicio Nutricional',
  description: 'Implementas la dieta de 14 días para limpiar el sistema digestivo de alérgenos comunes.'
}, {
  num: '03',
  title: 'Validación y Mantenimiento',
  description: 'Identificas los culpables reales y estableces una rutina que mantiene la "cubeta de histamina" vacía.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-cream-100" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-75">
            Cómo funciona
          </h2>
          <p className="text-lg text-charcoal-400" data-id="element-76">
            Tres pasos simples para devolverle la paz a tu perro.
          </p>
        </div>

        <div className="relative" data-id="element-77">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-cream-300 -z-10" data-id="element-78"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-79">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-80">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center border-4 border-cream-100 shadow-sm mb-6 text-2xl font-serif font-bold text-rust" data-id="element-81">
                  {step.num}
                </div>
                <h3 className="text-xl font-bold text-forest mb-4" data-id="element-82">
                  {step.title}
                </h3>
                <p className="text-charcoal-500 leading-relaxed" data-id="element-83">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}